import React from 'react'

import { Box } from '@material-ui/core'

import { CustomerCard, ContactCard } from '~/customer/components'
import GridTemplate3xN from '~/ui/components/GridTemplate3xN/GridTemplate3xN'

const PersonalDataTabContainer: React.FC = () => {
  return (
    <Box data-hook="personal-data-tab">
      <GridTemplate3xN>
        <CustomerCard />
        <ContactCard />
      </GridTemplate3xN>
    </Box>
  )
}

export default PersonalDataTabContainer
